import React, { type PropsWithChildren } from 'react'

type TooltipProps = PropsWithChildren<{
  title: string
}>

export const Tooltip: React.FC<TooltipProps> = ({ title, children }) => (
  <div className="group relative inline-block">
    {children}
    <div className="absolute left-1/2 top-[-1000px] z-20 mt-3 -translate-x-1/2 whitespace-nowrap rounded-md bg-background-inverse px-2 py-1 text-065 font-medium leading-alternate text-theme-default-accent1 opacity-0 group-hover:top-full group-hover:opacity-100">
      <span className="absolute left-1/2 top-[-3px] -z-10 h-2 w-2 -translate-x-1/2 rotate-45 bg-background-inverse"></span>
      {title}
    </div>
  </div>
)
